import { useContext } from "react";
import { FeedType } from "@finbackoffice/enums";
import { ConfigContextV2 } from "contexts";

export const useSportFeedType = () => {
    const { betProcessorFeedType } = useContext(ConfigContextV2);
    const isBCFeed = betProcessorFeedType === FeedType.BetConstruct;

    return { isBCFeed, betProcessorFeedType };
};
